// src/components/AddressReminder.js
//
// Record 610 (ruling 259): "a dismissible reminder at sign-in". When the signed-in person's profile holds no complete
// mailing address, one quiet line at the top of the page says so and offers to take it there and then (the Contact
// section, inline). "Not now" sets it aside for this browser session; it asks again at the next sign-in. It never
// blocks a page, never asks twice in one session, and stays silent when the profile could not be read (a failed read
// is not a missing address). App.js mounts it keyed on the uid, so a change of account starts it fresh.
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import ContactSection from './ContactSection';
import { reminderDue, reminderKey } from '../data/contactDetails';

function wasDismissed(uid) {
  try { return window.sessionStorage.getItem(reminderKey(uid)) === '1'; } catch (e) { return false; }
}
function dismiss(uid) {
  try { window.sessionStorage.setItem(reminderKey(uid), '1'); } catch (e) { /* storage unavailable - dismissed for this view only */ }
}

export default function AddressReminder({ user }) {
  const uid = user && user.uid;
  const [profile, setProfile] = useState(undefined);
  const [dismissed, setDismissed] = useState(() => wasDismissed(uid));
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let dead = false;
    if (!uid) return undefined;
    getDoc(doc(db, 'users', uid)).then((d) => { if (!dead) setProfile(d.exists() ? d.data() : null); }).catch(() => { /* unread: stay quiet */ });
    return () => { dead = true; };
  }, [uid]);
  if (!uid || !reminderDue(profile, dismissed)) return null;
  const notNow = () => { dismiss(uid); setDismissed(true); };
  return (
    <div role="status" style={{ background: '#132235', borderBottom: '1px solid #E8A020', color: '#DCE7F2', padding: '10px 16px', fontSize: 13 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <span>Your mailing address is not on the platform yet. It prints on the claims and letters you sign, and it is where the Carrier sends its replies. Would you add it?</span>
        {!open && (
          <span style={{ display: 'flex', gap: 8 }}>
            <button type="button" className="btn btn-primary btn-sm" onClick={() => setOpen(true)}>Add it now</button>
            <button type="button" className="btn btn-secondary btn-sm" onClick={notNow}>Not now</button>
          </span>
        )}
      </div>
      {open && <ContactSection user={user} startOpen embedded onSaved={(patch) => { setProfile((p) => ({ ...(p || {}), ...patch })); setOpen(false); }} />}
      {open && <div style={{ marginTop: 4 }}><button type="button" className="btn btn-secondary btn-sm" onClick={notNow}>Remind me next time</button></div>}
    </div>
  );
}
